import { render } from "./DesignerModal.vue?vue&type=template&id=63439572"
import script from "./DesignerModal.vue?vue&type=script&lang=js"
export * from "./DesignerModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__